
import 'react-tippy/dist/tippy.css';
import './App.css';

import Footer from 'components/layout/Footer';
import Viewer from 'components/layout/Viewer';

import SelectorDesktop from 'components/layout/desktop/SelectorDesktop';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow:column;
  padding:40px 60px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding:0px;
    height: 100%;
  }
  @media (min-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;

export const Top = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 40%;
  min-height:0;

  @media (max-width: 768px) {
    display:flex;
    flex-direction: column;
  }
`;

function LayoutDesktop() {
  return (
    <Container>
      <Top>
        <Viewer />
        <SelectorDesktop />
      </Top>
      <Footer />
    </Container>
  );
}

export default LayoutDesktop;
